export default __webpack_public_path__ + "static/media/whatsapp.1b27f4aa.svg";